import camelCase from 'lodash/camelCase';

// Load every sibling store module eagerly so Vuex receives the module objects
// during application startup.
const moduleFiles = import.meta.glob('./*.js', { eager: true });
const modules = {};

Object.entries(moduleFiles).forEach(([fileName, module]) => {
  if (fileName === './index.js') {
    return;
  }

  // Filter full stops and extension, then return a camel-case module name.
  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ''));
  modules[moduleName] = {
    namespaced: true,
    ...module.default,
  };
});

export default modules;
